import React from 'react';
import { Brain, Dumbbell, Users, Apple, UserCheck, Video } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { mockServices } from '../mock';

const iconMap = {
  Brain: Brain,
  Dumbbell: Dumbbell,
  Users: Users,
  Apple: Apple,
  UserCheck: UserCheck,
  Video: Video
};

const Services = () => {
  return (
    <section id="services" className="py-20 md:py-32 bg-brand-light-gray">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-brand-black mb-4">
              Services That Deliver Results
            </h2>
            <p className="text-lg md:text-xl text-brand-gray max-w-2xl mx-auto">
              Comprehensive coaching programs designed to build strength, confidence, and lasting change.
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {mockServices.map((service, index) => {
              const IconComponent = iconMap[service.icon];
              return (
                <Card
                  key={service.id}
                  className="border-none shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group cursor-pointer bg-white"
                  style={{
                    animationDelay: `${index * 100}ms`
                  }}
                >
                  <CardContent className="p-8">
                    <div className="mb-6">
                      <div className="w-14 h-14 bg-brand-orange/10 rounded-2xl flex items-center justify-center group-hover:bg-brand-orange group-hover:scale-110 transition-all duration-300">
                        <IconComponent className="text-brand-orange group-hover:text-white transition-colors" size={28} />
                      </div>
                    </div>
                    <h3 className="text-xl font-bold text-brand-black mb-3 leading-tight">
                      {service.title}
                    </h3>
                    <p className="text-brand-gray leading-relaxed">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;